import { takeLatest, put, call, select } from 'redux-saga/effects';
import {
    GET_PROFILES_REQUEST,
    getProfilesFailure,
    getProfilesSuccess
} from '../actions/profiles';
import { profilesAccessor } from '../selectors/profiles';
import { getProfiles } from '../services/profiles';
import { showGlobalError } from '../../app/actions/app';
import { accessTokenSelector } from '../../auth/selectors/token';

export const getProfilesWorker = function* ({ payload: { filters = {} } = {} } = {}) {

    try {
        const token = yield select(accessTokenSelector);

        const { data: { profiles, total } } = yield call(getProfiles, filters, token);
        yield put(getProfilesSuccess(profiles, total));
    } catch (err) {
        yield put(getProfilesFailure(err));
        yield put(showGlobalError(true, err));
    }
};

export const getProfileInstallerID = function* () {

    try {
        const { profiles } = yield select(profilesAccessor);
        const profileInstaller = profiles.find(profile => profile.code === "installer");

        return profileInstaller._id
    } catch (error) {
        throw error;
    }

}

export default [
    takeLatest(GET_PROFILES_REQUEST, getProfilesWorker),
];